(function () {
  function catalog() {
    const el = document.getElementById('vx-catalog');
    if (!el) return [];
    try {
      return JSON.parse(el.textContent);
    } catch (error) {
      return [];
    }
  }

  function fold(value) {
    return String(value || '')
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
  }

  function escapeHtml(value) {
    return String(value || '').replace(/[&<>"']/g, (char) => ({
      '&': '&amp;',
      '<': '&lt;',
      '>': '&gt;',
      '"': '&quot;',
      "'": '&#39;',
    }[char]));
  }

  function hits(query) {
    const needle = fold(query).trim();
    if (!needle) return [];
    return catalog().filter((item) => fold(`${item.needles} ${item.title} ${item.vendor}`).includes(needle));
  }

  function predictiveMarkup(term) {
    const items = hits(term).slice(0, 8);
    const lis = items
      .map(
        (item, index) => `
        <li id="vx-predictive-option-${index}" class="predictive-search__list-item" role="option" aria-selected="false">
          <a href="${escapeHtml(item.href)}" class="predictive-search__item link link--text vx-predictive__item" tabindex="-1">
            <img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.title)}" width="48" height="48">
            <div>
              <p class="predictive-search__item-heading h5">${escapeHtml(item.title)}</p>
              <p class="vx-predictive__meta">${escapeHtml(item.vendor)} · ${escapeHtml(item.price)}</p>
            </div>
          </a>
        </li>`
      )
      .join('');

    return `
      <div id="predictive-search-results" role="listbox">
        ${
          items.length
            ? `<div id="predictive-search-results-groups-wrapper" class="predictive-search__results-groups-wrapper">
                <div class="predictive-search__result-group">
                  <h2 class="predictive-search__heading text-body caption-with-letter-spacing">Productos</h2>
                  <ul class="predictive-search__results-list list-unstyled" role="group">${lis}</ul>
                </div>
              </div>`
            : ''
        }
        <div id="predictive-search-option-search-keywords" class="predictive-search__search-for-button">
          <button class="predictive-search__item predictive-search__item--term link link--text h5 animate-arrow" tabindex="-1" role="option" aria-selected="false">
            <span data-predictive-search-search-for-text>Buscar “${escapeHtml(term)}”</span>
          </button>
        </div>
        <span class="hidden" data-predictive-search-live-region-count-value data-total-results="${items.length}">
          ${items.length} resultados
        </span>
      </div>`;
  }

  function patchPredictive() {
    const Ctor = customElements.get('predictive-search');
    if (!Ctor || Ctor.prototype.__vxPatched) return;
    Ctor.prototype.__vxPatched = true;

    const original = Ctor.prototype.getSearchResults;
    Ctor.prototype.getSearchResults = function (searchTerm) {
      if (window.vxSearchUseDemo) {
        this.setLiveRegionLoadingState();
        this.renderSearchResults(predictiveMarkup(searchTerm));
        return;
      }

      const render = this.renderSearchResults.bind(this);
      this.renderSearchResults = function (markup) {
        const temp = document.createElement('div');
        temp.innerHTML = markup;
        const shopifyCount = parseInt(temp.querySelector('[data-total-results]')?.dataset.totalResults || '0', 10);
        render(shopifyCount > 0 ? markup : predictiveMarkup(searchTerm) || markup);
        this.renderSearchResults = render;
      };
      return original.call(this, searchTerm);
    };
  }

  if (customElements.get('predictive-search')) {
    patchPredictive();
  } else if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('predictive-search').then(patchPredictive);
  }
})();
